export default "__VITE_ASSET__H7G5kbmo__";